// eslint-disable-next-line simple-import-sort/imports
import 'react-app-polyfill/stable';

import React from 'react';
import ReactDOM from 'react-dom';
import {BrowserRouter} from 'react-router-dom';

import {createMuiTheme, MuiThemeProvider} from '@material-ui/core/styles';

import App from './App';
import './i18n';
import {muiTheme} from './zoomPalette';

import './index.css';

const theme = createMuiTheme(muiTheme);

// Start Mock Service Worker in development
if (process.env.NODE_ENV === 'development') {
  const {worker} = require('./mocks/zmail-api/browser');
  worker.start();
}


ReactDOM.render(
    <BrowserRouter>
      <MuiThemeProvider theme={theme}>
        <App />
      </MuiThemeProvider>
    </BrowserRouter>,
    document.getElementById('root'),
);
